import { render, staticRenderFns } from "./PageNavigator.vue?vue&type=template&id=bca42aee&scoped=true&"
import script from "./PageNavigator.vue?vue&type=script&lang=ts&"
export * from "./PageNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./PageNavigator.vue?vue&type=style&index=0&id=bca42aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca42aee",
  null
  
)

export default component.exports